import { createContext } from "react";
import { makeAutoObservable } from "mobx";
import { User } from "../../../types";

import axios from "axios";
import { AxiosError } from "../../../utils/api/axiosErrorType";

export class AuthStore {
  sessionId: string | null = null;
  user: User | null = null;
  menuIsOpened: boolean = false;

  constructor() {
    makeAutoObservable(this);
    this.load();
  }

  //TO DO fix ititalization error
  async getUserBySessionId() {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/me`, {
        headers: {
          Authorization: `Bearer ${this.sessionId}`,
        },
      });
      return data;
    } catch (error) {
      const err = error as AxiosError;
      const code = err?.response?.data?.error_code;
      if (code === 1001 || code === 1002 || code === 1003 || code === 1004) {
        AuthStoreInstance.logout();
      }
    }
  }

  load = () => {
    this.sessionId = window.localStorage.getItem("sessionId");
    this.sessionId &&
      this.getUserBySessionId().then((data) => {
        this.user = data;
      });
  };

  setSessionId = (id: string) => {
    this.sessionId = id;
    window.localStorage.setItem("sessionId", id);
    this.load();
  };

  logout = () => {
    this.sessionId = null;
    this.user = null;
    window.localStorage.removeItem("sessionId");
  };

  toggleMenu = (isOpen: boolean) => {
    this.menuIsOpened = isOpen;
  };
}

export const AuthStoreInstance = new AuthStore();
export const authStore = createContext(AuthStoreInstance);
